// removed by extract-text-webpack-plugin
module.exports = {"vitrade-textarea":"vitrade-textarea","form-control":"form-control"};


//////////////////
// WEBPACK FOOTER
// ./components/vitrade-forms/common/_textarea.scss
// module id = ./components/vitrade-forms/common/_textarea.scss
// module chunks = 0